import { StepTypeDefaults } from '@feedyou/schema'

import { RootState } from '../../../reducers'
import { getStepTypeDefaultsSelector } from '../../../selectors/dialog'
import { stepNlpSettingsSelector } from '../../botNlp/selectors'

export function isStepNlpEnabledSelector(state: RootState): boolean {
  return (
    isStepNlpEnabledInStepTypeDefaultsSelector(state) || !!stepNlpSettingsSelector(state)?.enabled
  )
}

/**
 * @deprecated  nlp settings can now be enabled/disabled in step NLP settings form
 * @param state
 */
export function isStepNlpEnabledInStepTypeDefaultsSelector(state: RootState): boolean {
  const defaults: StepTypeDefaults = getStepTypeDefaultsSelector(state)!
  return !!defaults!.question?.fuzzyAnswers
}
